type RouteAnalyticsLocation = {
  href?: string;
  pathname: string;
  search?: unknown;
  searchStr?: string;
  hash?: string;
};

export type RouteAnalyticsSnapshot = {
  pagePath: string;
  route: string;
  search: string;
};

export const getRouteAnalyticsSnapshot = (location: RouteAnalyticsLocation): RouteAnalyticsSnapshot => {
  const search = location.searchStr ?? '';
  const hash = location.hash ? `#${location.hash.replace(/^#/, '')}` : '';
  const pagePath = location.href ?? `${location.pathname}${search}${hash}`;

  return {
    pagePath,
    route: location.pathname,
    search,
  };
};
